import React from "react";
import RoundIcon from "../RoundIcon";
import Icon from "../Icon";

export default function PanelError({ text }) {
  return (
    <div className="panel bg-red flex-row">
      <RoundIcon color="red">
        <Icon name="Rejected" color="white" />
      </RoundIcon>
      <div className="panel-content">
        <p>{text}</p>
      </div>
    </div>
  );
}
